import { AccountSettingsType, TeamSettingsType } from '../types';

export const TEAM_SETTINGS_SIDEBAR_NAV_ITEMS = [
    {
        label: 'General',
        img: '/images/settings_outlined.svg',
        settingSection: TeamSettingsType.General,
    },
    {
        label: `Teammates`,
        img: '/images/user_group.svg',
        settingSection: TeamSettingsType.ManageTeamMembers,
    },
    {
        label: 'Subscription, Billing, & Invoices',
        img: '/images/briefcase.svg',
        settingSection: TeamSettingsType.SubscriptionAndBilling,
    },
    {
        label: 'Custom Domain & Email',
        img: '/images/dns.svg',
        settingSection: TeamSettingsType.WhiteLabelling,
    },
    {
        label: 'Renders and Usage',
        img: '/images/dns.svg',
        settingSection: TeamSettingsType.UsageAndLimits,
    },
    {
        label: 'Payments',
        img: '/images/briefcase.svg',
        settingSection: TeamSettingsType.Payments,
    },

];

    export const ACCOUNT_NAV_ITEMS = [
        {
            label: 'General',
            img: '/images/settings_outlined.svg',
            settingSection: AccountSettingsType.General,
        },
        {
            label: 'Subscription, Billing, & Invoices',
            img: '/images/briefcase.svg',
            settingSection: AccountSettingsType.SubscriptionAndBilling,
        },
    ];

